import { useState } from "react";
import { Sparkles, ChevronDown } from "lucide-react";
import { useFetch } from "../lib/api";

export const PeBriefingCard = () => {
  const { data } = useFetch("/pe/my-briefing");
  const [open, setOpen] = useState(false);
  const b = data?.briefing;
  if (!data) return null;
  return (
    <div className="c-surface mb-6 border-l-2 border-l-[#00E599] overflow-hidden" data-testid="pe-briefing-card">
      <button onClick={() => b && setOpen(!open)} className="w-full flex items-center justify-between gap-3 p-5 text-left" data-testid="pe-briefing-toggle">
        <div className="flex items-center gap-3 min-w-0">
          <Sparkles size={16} className="text-[#00E599] shrink-0" />
          <div className="min-w-0">
            <div className="text-sm font-semibold text-white">Weekly contractor briefing</div>
            <div className="text-xs text-slate-400" data-testid="pe-briefing-meta">
              {b ? `Week of ${b.week} · written by AI on ${new Date(b.generated_at).toLocaleDateString("en-IN", { dateStyle: "medium" })}` : "Your first briefing arrives on Monday at 9 am."}</div>
          </div>
        </div>
        {b && <span className="flex items-center gap-1 text-xs text-[#00E599] shrink-0">{open ? "Hide" : "Read"}<ChevronDown size={14} className={`transition-transform ${open ? "rotate-180" : ""}`} /></span>}
      </button>
      {b && open && <div className="px-5 pb-5">
        <iframe title="Weekly briefing" sandbox="" srcDoc={`<body style="margin:0;padding:16px;font-family:Arial,sans-serif;color:#111;background:#fff">${b.html}</body>`}
          className="w-full h-[520px] rounded-md bg-white" data-testid="pe-briefing-frame" />
      </div>}
    </div>);
};
